import type { SerialRowMap } from './cartTypes';
import { isCrossgradeSameHostBlocked } from './cartCrossgrade';
import { cartItemKey } from './cartItemKey';
import { isCrossgradeProduct, isUpgradeItem } from './cartLineKinds';

export function hasMissingRequiredHostApp(
  cart: any,
  serialRowsByItem: SerialRowMap,
): boolean {
  return (
    cart?.items?.some((item: any) => {
      const isCrossgrade = isCrossgradeProduct(item.productId);

      if (!isUpgradeItem(item)) {
        return !item.hostApplication?.id;
      }

      const key = cartItemKey(item);
      const rows = serialRowsByItem[key] || [];

      return rows.some((r) => {
        const missingSerial = !r.serial?.trim();
        const missingHost = isCrossgrade
          ? !r.targetHostApp?.id
          : !r.hostApp?.id;

        return missingSerial || missingHost;
      });
    }) ?? false
  );
}

export function isCartEmptyOrZero(items: any[]): boolean {
  return items.length === 0 || items.every((item: any) => item.quantity < 1);
}

export function hasInvalidUpgradeSerials(
  items: any[],
  serialRowsByItem: SerialRowMap,
): boolean {
  return items.some((item: any) => {
    if (!isUpgradeItem(item)) return false;
    const key = cartItemKey(item);
    const rows = serialRowsByItem[key] || [];
    const crossgrade = isCrossgradeProduct(item.productId);
    return rows.some(
      (r) =>
        r.status === 'invalid' ||
        (crossgrade && isCrossgradeSameHostBlocked(r)),
    );
  });
}

export function computeItemsCount(
  items: any[],
  serialRowsByItem: SerialRowMap,
): number {
  return items.reduce((n: number, it: any) => {
    if (isUpgradeItem(it)) {
      return n + (serialRowsByItem[cartItemKey(it)]?.length || 0);
    }
    return n + (it.quantity || 0);
  }, 0);
}
